import axios from 'axios'
import { useAuthAdminStore } from '@/stores/AuthAdminStore'
import { Notification } from './notifications'
import router from '@/router'
import { isErroSemAcessoOwner, mensagemDoErro } from './errosSessao'

const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND,
  headers: {
    'Content-Type': ' multipart/form-data',
  },
})

// Request interceptor
request.interceptors.request.use(
  function (config) {
    const authStore = useAuthAdminStore()

    if (authStore.token) {
      config.headers.set('Authorization', `Bearer ${authStore.token}`)
    }

    // Faz alguma coisa antes da requisição ser enviada
    config.headers.set('owner-url', window.location.host)
    // config.headers.set('Content-Type', 'application/json')

    // Para funcionar com arquivos enviados do frontend
    const isFormData = config.data instanceof FormData
    if (!isFormData) {
      config.headers.set('Content-Type', 'application/json')
    } else {
      config.headers.delete('Content-Type')
    }

    return config
  },
  function (error) {
    // Faz alguma coisa com o erro da requisição
    return Promise.reject(error)
  },
)

// Limpa a sessão e leva ao login do ambiente da rota atual (401 e 403 de owner)
function encerrarSessao(authStore, mensagem) {
  const currentRoute = router.currentRoute.value
  const ambient = currentRoute.meta.ambient

  let destination = 'admin-login'
  let params = {}

  if (ambient === 'afiliado-loja') {
    destination = 'affiliate-loja-login'
    if (currentRoute.params.code) {
      params = { code: currentRoute.params.code }
    }
  } else if (ambient === 'afiliado-portal') {
    destination = 'affiliate-portal-login'
  } else if (ambient === 'ecommerce') {
    destination = 'ecommerce-login'
  }

  authStore.ClearSessionData()

  // Evita disparar a notificação e o push se já estivermos na rota de login correta
  if (currentRoute.name !== destination) {
    Notification.info(mensagem)
    router.push({ name: destination, params })
  }
}

// Response interceptor
request.interceptors.response.use(
  function (response) {
    // Qualquer código de status que dentro do limite de 2xx faz com que está função seja acionada
    // Faz alguma coisa com os dados de resposta
    return response
  },
  async function (error) {
    const authStore = useAuthAdminStore()
    // Qualquer código de status que não esteja no limite do código 2xx faz com que está função seja acionada
    // Faz alguma coisa com o erro da resposta

    if (error.response && error.response.status === 401) {
      encerrarSessao(authStore, 'Sua sessão expirou. Por favor, faça login novamente.')

    } else if (isErroSemAcessoOwner(error)) {
      // Todas as rotas recusam esta sessão, inclusive user/get/: sincronizar permissões entraria em loop
      encerrarSessao(authStore, 'Sua sessão não é válida para esta empresa. Faça login novamente.')

    } else if (error.response && error.response.status === 403) {
      // A `message` do backend diz qual permissão faltou. Consultas em segundo plano que tratam o
      // próprio 403 passam `silenciarErroPermissao: true` na config para não exibir o aviso.
      if (!error.config?.silenciarErroPermissao) {
        Notification.error(mensagemDoErro(error) || 'Não possui permissão para realizar essa operação.')
      }
      await authStore.synchronizeUserPermissions()
    }

    return Promise.reject(error)
  },
)

export default request
